import React, { useEffect, useState, useRef } from "react"

import {
  Col,
  Row,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Progress,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap"

import { connect } from "react-redux"
import { Link, useLocation } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"

// Import images
import SubstrateImg from "../../assets/images/SubstrateImg.png"
import InoculationImg from "../../assets/images/inoculation.png"
import FruitingImg from "../../assets/images/fruiting1.png"
import HarvestingImg from "../../assets/images/harvesti.png"

import QR from "../../assets/images/qr.png"
import axios from "axios"
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const BagDetails = props => {
  document.title = "Bag List | My Urban Farms"


  const breadcrumbItems = [
    { title: "Batches", link: "/batches" },
    { title: "Bag List", link: "#" },
  ]
  const location = useLocation();
  const batchKey = location.state?.batchKey;
  const selectedFarmKey = location.state?.selectedFarmKey;

  // search state
  const [searchTerm, setSearchTerm] = useState("")  
  const [searchQuery, setSearchQuery] = useState("")


  useEffect(() => {
    props.setBreadcrumbItems("Bag List", breadcrumbItems)
    fetchProcesses();
    fetchSavedSequence();
  }, [])

  const [sequenceList, setSequenceList] = useState([]);

  const fetchSavedSequence = async () => {
    try {
      const URL = `${process.env.REACT_APP_API_BASE_URL}/getProcessSequence/process/`;
      const res = await axios.post(URL, {farmKey: selectedFarmKey});
      const seq = res.data?.message?.data?.data || [];

      if (Array.isArray(seq)) {
        setSequenceList(seq);   // <-- STORE sequence list
      }
    } catch (err) {
      console.error("Failed to fetch sequence:", err);
    }
  };



  // State for bags
  const [bags, setBags] = useState([]);
  const [processList, setProcessList] = useState([]);



  

  const fetchProcesses = async () => {
    try {
      // 1. Fetch process list
      const processRes = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getAllProcess/process/`, {farmKey: selectedFarmKey}
      );
      const processList = processRes.data?.message?.data || [];

      // 2. Fetch process sequence
      const seqRes = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getProcessSequence/process/`, {farmKey: selectedFarmKey}
      );
      const sequenceList = seqRes.data?.message?.data?.data || [];

      // 3. Merge: attach position to each process
      const merged = processList.map(proc => {
        const seq = sequenceList.find(s => s.fk_process_key === proc.pk_process_key);

        return {
          ...proc,
          process_position: seq ? seq.process_position : null, // if not found → null
        };
      });

      // 4. Save combined list
      setProcessList(merged);
    } catch (err) {
      console.error("Failed to load processes", err);
    }
  };


  function parseDuration(duration) {
    if (!duration) return { days: 0, hours: 0 };

    const lower = duration.toLowerCase();

    // Example formats: "10 days", "12 hrs", "5 day", "1 hr"
    const dayMatch = lower.match(/(\d+)\s*day/);
    const hourMatch = lower.match(/(\d+)\s*hr/);

    return {
      days: dayMatch ? parseInt(dayMatch[1]) : 0,
      hours: hourMatch ? parseInt(hourMatch[1]) : 0,
    };
  }

  function calculateProgress(processDate, processDuration) {
    if (!processDate || !processDuration) return 0;

    const { days, hours } = parseDuration(processDuration);

    const start = new Date(processDate);
    const now = new Date();

    const diffMs = now - start;

    const totalMs =
      (days * 24 * 60 * 60 * 1000) +
      (hours * 60 * 60 * 1000);

    if (totalMs <= 0) return 0;

    let progress = (diffMs / totalMs) * 100;

    if (progress < 0) progress = 0;
    if (progress > 100) progress = 100;

    return Math.floor(progress);
  }


    useEffect(() => {
    if (!batchKey) {
      console.error("Batch key missing");
      return;
    }

    (async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/getBagsByBatch/batch`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ fk_batch_key: batchKey }),
          }
        );

        const data = await res.json();
        console.log("API RESP", data);

        const bagsArray =
          data?.success === 1 && // api call successful
            data?.bags?.data?.bags && // bag data exist
            Array.isArray(data.bags.data.bags) // it will store data in array format
            ? data.bags.data.bags // data is true it use bag
            : []; // data is false use empty array

        const formatted = bagsArray.map(b => ({
          pk_bag_manage_key: b.pk_bag_manage_key,
          id: b.bag_num,
          bagKey: b.bag_key,
          batchId: b.batch_num,
          processKey: b.fk_process_key,
          processSeqKey: b.fk_process_seq_key,
          batchName: b.batch_name,
          currentStage: b.current_stage,
          startDateDate: b.process_date,
          startDate: b.process_created_on,
          processDuration: b.process_duration,
          progress: calculateProgress(b.process_created_on, b.process_duration),
          status: "In-Progress",
          qr_image: b.qr_image,
          processImage: b.process_image
            ? `${process.env.REACT_APP_IMAGE_URL}/${b.process_image}`
            : null,
        }));

        setBags(formatted);
      } catch (error) {
        console.error("Failed to load bags", error);
      }
    })();
  }, [batchKey]);

 
  function getIndianDate() {
    const date = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Kolkata"
    });

    return new Date(date).toISOString().slice(0, 10);
  }
  const adminKey = sessionStorage.getItem("pk_admin_key");


  const handleStageChange = async () => {
    if (!selectedBag || !newStage) return;

    const payload = {
      fk_batch_key: batchKey,
      fk_bag_key: selectedBag.bagKey,
      fk_process_key: newStage.pk_process_key,
      fk_process_seq_key: newStage.pk_sequence_key,
      process_name: newStage.process_name,
      process_date: getIndianDate(),
      status: '1',
      created_by: adminKey,
      fk_farm_key: selectedFarmKey
    };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/changeProcess/bag/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      const result = await res.json();


      if (result?.message?.success === true) {
        toast.success(result?.message?.message || "Stage updated successfully!");
        setModalOpen(false);
        fetchProcesses();
        fetchSavedSequence();
        

      } else {
        toast.error(result?.message?.message || "Failed to update stage");
      }
    } catch (err) {
      console.log(err);
      toast.error("Error updating stage");
    }
  };




  // Modal state
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedBag, setSelectedBag] = useState(null)
  const [newStage, setNewStage] = useState("")

  // Get stage image based on current stage
  const getStageImage = stage => {
    const images = {
      Substrate: SubstrateImg,
      Inoculation: InoculationImg,
      Fruiting: FruitingImg,
      Harvesting: HarvestingImg,
    }
    return images[stage] || FruitingImg
  }

  const getStatusColor = status => {
    return status === "Completed" ? "success" : "warning"
  }

  // State to track which dropdown is open - using bag id as key
  const [openDropdown, setOpenDropdown] = useState(null)

  const toggleDropdown = bagId => {
    setOpenDropdown(openDropdown === bagId ? null : bagId)
  }

  // Open change stage modal
  const openChangeStageModal = bag => {
    setSelectedBag(bag)
    setNewStage(bag.currentStage)
    setModalOpen(true)
    setOpenDropdown(null) // Close dropdown
  }

  // Handle stage change
  // const handleStageChange = () => {
  //   if (!selectedBag || !newStage) return

  //   // Calculate new progress based on stage
  //   const stageProgress = {
  //     Substrate: 25,
  //     Inoculation: 50,
  //     Fruiting: 75,
  //     Harvesting: 100,
  //   }

  //   // Update bags state
  //   setBags(prevBags =>
  //     prevBags.map(bag =>
  //       bag.id === selectedBag.id
  //         ? {
  //           ...bag,
  //           currentStage: newStage,
  //           progress: stageProgress[newStage],
  //           status: newStage === "Harvesting" ? "Completed" : "In-Progress",
  //         }
  //         : bag
  //     )
  //   )

  //   // Close modal
  //   setModalOpen(false)
  //   setSelectedBag(null)
  //   setNewStage("")
  // }
  const printableRef = useRef();

  const handlePrint = () => {
    const printContents = printableRef.current.innerHTML;

    const printWindow = window.open("", "", "width=900,height=650");

    printWindow.document.open();
    printWindow.document.write(`
    <html>
      <head>
        <title>Bag Print - Batch ${bags[0]?.batchName}</title>
        <style>
          body { font-family: Arial; padding: 20px; }
          img { max-width: 100%; }
        </style>
      </head>
      <body>${printContents}</body>
    </html>
  `);
    printWindow.document.close();

    // IMPORTANT: wait for all images to load
    printWindow.onload = () => {
      const imgs = printWindow.document.images;
      let loaded = 0;

      if (imgs.length === 0) {
        printWindow.print();
        printWindow.close();
        return;
      }

      for (let i = 0; i < imgs.length; i++) {
        imgs[i].onload = () => {
          loaded++;
          if (loaded === imgs.length) {
            printWindow.print();
            printWindow.close();
          }
        };

        imgs[i].onerror = () => {
          loaded++;
          if (loaded === imgs.length) {
            printWindow.print();
            printWindow.close();
          }
        };
      }
    };
  };

  const [loadingPDF, setLoadingPDF] = useState(false);


  const handleDownloadPDF = async () => {
    setLoadingPDF(true);       // start loader

    try {
      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();
      const margin = 10;
      const columns = 5;
      const qrSize = 37;
      const colWidth = (pageWidth - margin * 2) / columns;
      // const rowHeight = 35;
      const rowHeight = qrSize + 10;

      let x = margin;
      let y = 30;

      pdf.setFontSize(16);
      pdf.text(
        `Batch: ${bags[0]?.batchName} – ${bags[0]?.batchId}`,
        pageWidth / 2,
        15,
        { align: "center" }
      );

      for (let i = 0; i < bags.length; i++) {
        const bag = bags[i];
        const qrUrl = `${process.env.REACT_APP_QRIMAGE_URL}/${bag.qr_image}`;
        const qrBase64 = await getImageAsBase64(qrUrl);

        pdf.addImage(
          qrBase64,
          "PNG",
          x + (colWidth - qrSize) / 2,
          y,
          qrSize,
          qrSize
        );

        pdf.setFontSize(10);
        pdf.text(`Bag ${bag.id}`, x + colWidth / 2, y + qrSize + 3, { align: "center" });

        // pdf.setFontSize(8);
        // pdf.text(`Batch ${bag.batchId}`, x + colWidth / 2, y + qrSize + 8, { align: "center" });

        x += colWidth;

        if ((i + 1) % columns === 0) {
          x = margin;
          y += rowHeight;
        }

        if (y + rowHeight > 280) {
          pdf.addPage();
          x = margin;
          y = 20;

          pdf.setFontSize(16);
          pdf.text(
            `Batch: ${bags[0]?.batchName} – ${bags[0]?.batchId}`,
            pageWidth / 2,
            15,
            { align: "center" }
          );
        }
      }

      pdf.save(`Batch_${bags[0]?.batchName}_QR_List.pdf`);
    } finally {
      setLoadingPDF(false);
    }
  };

  const getImageAsBase64 = (url) =>
    new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.src = url;
    });


  useEffect(() => {
    if (selectedFarmKey) {
      fetchSavedSequence(selectedFarmKey);
      fetchProcesses(selectedFarmKey);
    }
  }, [selectedFarmKey]);

  // NEW: Filter bags based on search
    
  const filteredBags = bags.filter(bag => {
    if (!searchQuery) return true;
    
    const query = searchQuery.toLowerCase().trim();
    
    // Check if bag ID matches exactly or partially
    const bagIdMatch = bag.id.toString().toLowerCase().includes(query);
    
    // Check if batch ID matches
    const batchIdMatch = bag.batchId.toString().toLowerCase().includes(query);
    
    // Check if current stage matches
    const stageMatch = bag.currentStage && bag.currentStage.toLowerCase().includes(query);
    
    // Check if start date matches
    const dateMatch = bag.startDateDate && bag.startDateDate.toLowerCase().includes(query);
    
    return bagIdMatch || batchIdMatch || stageMatch || dateMatch;
  });

 
  // // NEW: Clear search
  // const clearSearch = () => {
  //   setSearchTerm("");
  //   setSearchQuery("");
  // };

  

  



  return (
    <React.Fragment>
      {/* Header Section */}
      <div className="d-flex align-items-center justify-content-between mb-3 gap-3">
        <Breadcrumb />
        {/* <Button type="button" color="primary" className="waves-effect waves-light">
          <i className="mdi mdi-plus me-1"></i>
          Add New Bag
        </Button> */}
        <div className="d-flex justify-content-end gap-2">
          
          
          <Button color="primary" onClick={handlePrint}>
            <i className="mdi mdi-printer me-1"></i> Print
          </Button>

          <Button color="primary" onClick={handleDownloadPDF} disabled={loadingPDF}>
            {loadingPDF ? (
              <span>
                <i className="mdi mdi-loading mdi-spin me-1"></i> Downloading...
              </span>
            ) : (
              <span>
                <i className="mdi mdi-file-pdf-box me-1"></i> Download PDF
              </span>
            )}
          </Button>

        </div>
      </div>
      

      {/*  Search Bar */}
      <div className="d-flex align-items-center justify-content-end mb-3">
        <Input
          type="text"
          placeholder="Search "
          value={searchTerm}
          onChange={e => {
            setSearchTerm(e.target.value);
            setSearchQuery(e.target.value);
          }}
          style={{ width: "250px", height: "38px" }}
          className="me-2"
        />
                
      </div>

      {/* Bags Grid */}
      <Row>
        {filteredBags.map(bag => (
          <Col xs={12} sm={6} lg={6} xl={4} xxl={3} key={bag.id} className="mb-4">
            <Card className="border shadow-sm h-100">
              {/* Header */}
              <CardHeader className="bg-light border-bottom">
                <div className="d-flex align-items-center justify-content-between">
                  {/* <div>
                    <h5 className="mb-1 fw-semibold">Bag ID: {bag.id}</h5>
                    <p className="mb-0 text-muted small">
                      <i className="mdi mdi-package-variant me-1"></i>
                      Batch: {bag.batchId}
                    </p>
                  </div> */}
                  <div className="d-flex align-items-center gap-2">
                    <Badge color={getStatusColor(bag.status)} className="px-2 py-1">
                      {bag.status}
                    </Badge>
                    <Dropdown
                      isOpen={openDropdown === bag.id}
                      toggle={() => toggleDropdown(bag.id)}
                    >
                      <DropdownToggle
                        tag="button"
                        className="btn btn-link text-muted p-0 border-0 shadow-none"
                      >
                        <i className="mdi mdi-dots-vertical fs-5"></i>
                      </DropdownToggle>
                      <DropdownMenu end>
                        <Link to="/admin/bag-details" state={{ batchKey: batchKey, bagKey: bag.bagKey, pk_bag_manage_key: bag.pk_bag_manage_key, selectedFarmKey: selectedFarmKey }}> <DropdownItem>
                          <i className="mdi mdi-eye-outline me-2"></i>
                          View Details
                        </DropdownItem></Link>
                        <DropdownItem onClick={() => openChangeStageModal(bag)}>
                          <i className="mdi mdi-swap-horizontal me-2"></i>
                          Change Stage
                        </DropdownItem>
                        <DropdownItem divider />
                        {/* <DropdownItem className="text-danger">
                          <i className="mdi mdi-delete-outline me-2"></i>
                          Delete Bag
                        </DropdownItem> */}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              </CardHeader>

              {/* Body */}
              <CardBody className="p-3">
                {/* Stage Image and Info */}
                <div className="d-flex gap-3 mb-3">
                  {/* Stage Image */}
                  {/* <div className="flex-shrink-0">
                    <img
                      src={bag.processImage}
                      alt={bag.currentStage}
                      className="rounded"
                      style={{ width: "80px" }}
                    />
                  </div> */}

                  <div className="flex-shrink-0" style={{ width: "80px", height: "80px" }}>
                    {bag.processImage ? (
                      <img
                        src={bag.processImage}
                        alt={bag.currentStage}
                        className="rounded"
                        style={{ width: "80px", height: "80px", objectFit: "cover" }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.style.display = "none";
                          e.target.parentNode.innerHTML = `<div class='text-muted small'>No Image</div>`;
                        }}
                      />
                    ) : (
                      <div className="text-muted small d-flex align-items-center justify-content-center h-100">
                        No Image
                      </div>
                    )}
                  </div>


                  {/* Stage Details */}
                  <div className="flex-grow-1">
                    <div className="mb-2">
                      <span className="text-muted small d-block">Current Stage</span>
                      <span className="fw-semibold text-primary">
                        {bag.currentStage}
                      </span>
                    </div>
                    <div className="mb-2">
                      <span className="text-muted small d-block">Start Date</span>
                      <span className="fw-medium">{bag.startDateDate}</span>
                    </div>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_QRIMAGE_URL}/${bag.qr_image}`}
                    alt="QR Code"
                    style={{ width: "100px", height: "100px" }}
                  ></img>
                </div>

                {/* Progress Section */}
                {/* <div className="border-top pt-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="text-muted small fw-medium">Progress</span>
                    <span className="fw-semibold text-dark">{bag.progress}%</span>
                  </div>
                  <Progress
                    striped
                    animated
                    value={bag.progress}
                    color="primary"
                    style={{ height: "6px" }}
                    className="mb-0"
                  />
                </div> */}
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      
      

      <div style={{ display: "none" }}>
        <div ref={printableRef} style={{ padding: "20px" }}>

          <h2 style={{ textAlign: "center", marginBottom: "40px" }}>
            Batch: {bags[0]?.batchName} – {bags[0]?.batchId}
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(7, 1fr)",
              columnGap: "20px",
              rowGap: "20px",
              justifyItems: "center",
            }}
          >
            {bags.map((bag) => (
              <div key={bag.id} style={{ textAlign: "center" }}>
                <img
                  src={`${process.env.REACT_APP_QRIMAGE_URL}/${bag.qr_image}`}
                  width="140"
                  height="140"
                />
                <div style={{ marginTop: "5px", fontSize: "12px" }}>
                  Bag {bag.id}
                </div>
                {/* <div style={{ marginTop: "8px", fontSize: "10px" }}>
                  Batch {bag.batchId}
                </div> */}
              </div>
            ))}
          </div>

        </div>

      </div>


      <style jsx>{`
        .hover-text-primary:hover {
          color: #556ee6 !important;
        }
        .hover-text-danger:hover {
          color: #f46a6a !important;
        }
      `}</style>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(BagDetails)